import axios from "axios";

const SESSION_MARKER = "session";

/**
 * Login function.
 *
 * @param {string} email - E-mail Address used for authentication.
 * @param {string} password - Password used for authentication.
 * @returns {{ success: boolean, payload: object }} - The result object containing success and payload.
 */
const login = async (email, password) =>
  await axios
    .post("assets/persons/auth/login", {
      email,
      password,
      // Keep the token in an HttpOnly cookie: it isn't sent back here, so no
      // script on the page can read it.
      cookieSession: true,
    })
    .then(({ data }) => {
      /**
       * Clear the local storage first
       */
      const companyId = localStorage.getItem("companyId");
      // localStorage.clear();
      const { auth } = data.payload;
      // Only says "signed in" (the app gates on it); the real token is the
      // cookie. Sent as the Authorization value, the server ignores it.
      data.payload.token = SESSION_MARKER;
      localStorage.setItem("token", SESSION_MARKER);
      localStorage.setItem("email", auth.email);
      // Not the whole profile (it stays in memory): just who this is.
      localStorage.setItem(
        "auth",
        JSON.stringify({ _id: auth._id, email: auth.email }),
      );
      // The little that "Welcome back" needs after a Log out.
      localStorage.setItem(
        "rememberedAccount",
        JSON.stringify({ email: auth.email, pid: auth.pid, isMale: auth.isMale }),
      );
      localStorage.removeItem("activePlatform");
      // Put back as it was. (Re-encoding it added a layer of quotes on every
      // sign-in, and stored the text "null" when there was none.)
      if (companyId !== null) localStorage.setItem("companyId", companyId);

      return data;
    })
    .catch((error) => {
      const { response } = error || {};
      const { error: errorLabel, message } = response?.data || {};
      throw new Error(
        message ? `${errorLabel}: ${message}` : errorLabel || error.message
      );
    });

export default login;
